import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Footer(){
    const [showPopup, setShowPopup] = useState(false);
        const handleDevClick = () => {
            setShowPopup(true);
            setTimeout(() => setShowPopup(false), 2000); // Hide after 2 seconds
        };
    return(
        
    
    <div className='low-part-of-landing-page'>
        {showPopup && (
                <div style={{
                position: 'fixed',
                top: '20px',
                right: '20px',
                backgroundColor: '#333',
                color: 'white',
                padding: '15px 25px',
                borderRadius: '8px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                zIndex: 1000,
                animation: 'fadeIn 0.3s'
                }}>
                In Development
                </div>
            )}
        <div>Engineering Cubes for Contracting</div>
        <div>
        <Link to='/contact' style={{ textDecoration: 'none', color: 'inherit' }}>
          <div onClick={handleDevClick} style={{ cursor: 'pointer' }}>Come visit us here</div>
        </Link>
          <Link to='/contact' style={{ textDecoration: 'none', color: 'inherit' }}>
            <div  style={{ cursor: 'pointer' }}>Contact us here</div>
          </Link>            
            
        </div>
    </div>




    )
}

export default Footer;